import { FileUploadModule } from 'primeng/fileupload';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { BlockUIModule } from 'primeng/blockui';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { NgModule } from '@angular/core';
import {CheckboxModule} from 'primeng/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {DropdownModule} from 'primeng/dropdown';

@NgModule({
    exports:[
        FileUploadModule,
        CardModule,
        PanelModule,
        BlockUIModule,
        ToastModule,
        TableModule,
        CheckboxModule,
        MatDialogModule,
        DropdownModule
    ],
})
export class PrimengModule{}